<nz-avatar-group *ngIf="list && list.length > 0; else emptyTester" class="avatar-group">
    <nz-avatar
            *ngFor="let user of list.slice(0, maxVisibleAvatars)"
            [nzSize]="size"
            [style]="{backgroundColor: getBackgroundColor(user.label)}"
            [ngClass]="{'inactive-member': !isMemberActive(user)}"
            [nzSrc]="user.avatar ? getAvatarImage(user.avatar) : null"
            [nzText]="!user.avatar ? (user.label | capitalize) : null"
            nz-tooltip
            [nzTooltipTitle]="isMemberActive(user) ? user.label : user.label + ' (Inactive)'"
    ></nz-avatar>
    <nz-avatar
            *ngIf="list.length > maxVisibleAvatars"
            [nzText]="'+' + (list.length - maxVisibleAvatars)"
            nz-dropdown
            [nzDropdownMenu]="menu"
            nzTrigger="hover"
            [ngStyle]="{
                'background-color': '#ececec',
                'color': '#000',
                'position': 'relative',
                'cursor': 'pointer',
            }"
            nzClickHide="false"
    ></nz-avatar>
    <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu nzDropdownMenu>
            <li
                nz-menu-item
                *ngFor="let member of list.slice(maxVisibleAvatars, list.length)"
                [nzValue]="member.value"
            >
                <nz-avatar
                        [nzSize]="size"
                        [nzSrc]="member.avatar ? member.avatar : null"
                        [nzText]="!member.avatar ? (member.label | capitalize) : null"
                        [ngStyle]="{'background-color': getBackgroundColor(member.label), 'color': '#fff'}">
                </nz-avatar>
                {{ isMemberActive(member) ? member.label : member.label + ' (Inactive)' }}
            </li>
        </ul>
    </nz-dropdown-menu>

</nz-avatar-group>
<ng-template #emptyTester>
    <div  class="avatar-group">
        <nz-avatar nzIcon="user" [nzSize]="size" nz-tooltip nzTooltipTitle="Unassigned"></nz-avatar>
    </div>
</ng-template>
